"use client";

import Link from "next/link";
import { useTranslation } from "react-i18next";
import { ExternalLink, MapPin, Clock } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";

const WHATSAPP_URL = "https://wa.me/5492944636295";
const GOOGLE_MAPS_URL = "https://www.google.com/maps/search/?api=1&query=Eduardo+Sfeir+2827+El+Bolsón+Río+Negro+Argentina";

export default function HomeContactBlock() {
  const { t } = useTranslation();

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-slate-50 to-white py-14 sm:py-16 md:py-20">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary/20 to-transparent" aria-hidden />

      <div className="relative mx-auto w-full max-w-6xl px-4 sm:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary/90 sm:text-sm">
            {t("footer.ourLocation")}
          </p>
          <h2 className="mt-2 text-balance text-2xl font-black tracking-tight text-slate-900 sm:text-3xl">
            {t("common.venueName")}
          </h2>
        </div>

        <div className="mt-10 grid gap-5 sm:mt-12 sm:grid-cols-3 sm:gap-6 lg:mt-14">
          <div className="flex h-full flex-col rounded-2xl border border-slate-200/90 bg-white p-6 shadow-sm ring-1 ring-slate-900/5 sm:p-7">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-primary-soft text-primary">
              <MapPin className="h-6 w-6" strokeWidth={2} aria-hidden />
            </div>
            <div className="mt-5 flex flex-1 flex-col text-center">
              <p className="text-sm font-semibold leading-snug text-slate-900">{t("contact.address")}</p>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{t("contact.landmark")}</p>
            </div>
            <div className="mt-6 shrink-0 border-t border-slate-100 pt-6">
              <Link
                href={GOOGLE_MAPS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex w-full items-center justify-center gap-2 rounded-xl border border-primary/25 bg-primary-soft/50 py-3 text-sm font-semibold text-primary transition hover:bg-primary-soft"
              >
                {t("contact.openInMaps")}
                <ExternalLink className="h-4 w-4 shrink-0 opacity-80" aria-hidden />
              </Link>
            </div>
          </div>

          <div className="flex h-full flex-col rounded-2xl border border-slate-200/90 bg-white p-6 shadow-sm ring-1 ring-slate-900/5 sm:p-7">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-primary-soft text-primary">
              <Clock className="h-6 w-6" strokeWidth={2} aria-hidden />
            </div>
            <div className="mt-5 flex flex-1 flex-col text-center">
              <p className="text-sm font-semibold text-slate-900">{t("footer.weAreOpen")}</p>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">{t("footer.hours")}</p>
            </div>
          </div>

          <div className="flex h-full flex-col rounded-2xl border border-slate-200/90 bg-white p-6 shadow-sm ring-1 ring-slate-900/5 sm:p-7">
            <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-xl bg-[#25D366]/15 text-[#128C7E]">
              <WhatsAppIcon size={28} className="h-7 w-7" />
            </div>
            <div className="mt-5 flex flex-1 flex-col text-center">
              <p className="text-sm font-semibold text-slate-900">{t("footer.sendMessage")}</p>
            </div>
            <div className="mt-6 shrink-0 sm:mt-7">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#25D366] px-4 py-3.5 text-sm font-semibold text-white shadow-md transition hover:bg-[#20bd5a]"
              >
                {t("contact.chatWhatsApp")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
